<template>
  <div
    v-if="isLoading || books.length"
    class="container pt-56 pt-lg-80 pb-64 pb-lg-80"
  >
    <div class="row mb-40 pt-lg-16">
      <div class="col-md-10 offset-md-1 text-center">
        <h2 class="mb-16 mb-lg-24">
          {{ $label('books.relatedBooksCarousel.title') }}
        </h2>
        <p class="mb-16 mb-lg-24">
          {{ $label('books.relatedBooksCarousel.subtitle') }}
        </p>

        <NuxtLink :to="shopHref" class="btn btn-secondary">
          {{ $label('books.relatedBooksCarousel.button') }}
        </NuxtLink>
      </div>
    </div>

    <div v-if="isLoading" class="row justify-content-center mb-64">
      <div class="col-12 col-md-10">
        <div class="text-center">
          <BaseSpinner />
        </div>
      </div>
    </div>

    <div
      v-else-if="books.length"
      class="row justify-content-center flex-nowrap pb-lg-48"
    >
      <div class="carousel__prev"></div>
      <div cols="12" md="10" class="col-12 col-md-10 position-relative">
        <swiper-container
          slides-per-view="2"
          slides-per-group="2"
          :breakpoints="breakpoints"
          :navigation="true"
          navigation-next-el=".carousel__next"
          navigation-prev-el=".carousel__prev"
          :pagination="true"
          :pagination-clickable="true"
          :a11y="true"
        >
          <swiper-slide v-for="book in books" :key="book.id">
            <NuxtLink :to="`/shop/boek/${book.slug}`">
              <div class="pb-16 pb-md-24">
                <CarouselBook
                  :cover="book.cover"
                  :title="book.title"
                  :author="getBookAuthor(book)"
                  :price="{
                    listPrice: book.listPrice,
                    salePrice: book.salePrice
                  }"
                />
              </div>
            </NuxtLink>
          </swiper-slide>
        </swiper-container>
      </div>
      <div class="carousel__next"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia'
import { useShopStore } from '~/stores/shop'
import { PAGES } from '~/utils/constants'
import CarouselBook from '~/components/CarouselBook'
import { register } from 'swiper/element/bundle'

register()

export default {
  components: {
    CarouselBook
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      books: [],
      isLoading: true,
      breakpoints: {
        992: {
          slidesPerView: 4,
          slidesPerGroup: 4
        }
      }
    }
  },
  computed: {
    shopHref() {
      return PAGES.shop
    }
  },
  async mounted() {
    await this.getBooks()
  },
  methods: {
    ...mapActions(useShopStore, ['getRelatedBooks']),
    async getBooks() {
      try {
        this.isLoading = true
        this.books = await this.getRelatedBooks(this.slug)
      } catch (error) {
        this.$sentryCaptureException(error)
      } finally {
        this.isLoading = false
      }
    },
    getBookAuthor(book) {
      return book.author?.name || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.book-product {
  margin-left: 16px;
  margin-right: 16px;
}

a {
  text-decoration: none;
  color: $black;
}
</style>
